import type {AppSyncErrorPayload} from '../types';
import {isAppSyncErrorPayload} from './isAppSyncErrorPayload';

const UNAUTHORIZED_ERROR_TYPE = 'UnauthorizedException';
const UNAUTHORIZED_ERROR_CODE = 401;

/**
 * The single source of truth for "this AppSync payload is an auth rejection".
 * Used both to suppress Sentry noise (these are expected, not bugs) and to trigger
 * the WebSocket token-refresh self-heal.
 */
export const isAuthErrorPayload = (value: unknown): value is AppSyncErrorPayload =>
  isAppSyncErrorPayload(value) &&
  value.errors.some(
    (entry) =>
      entry.errorType === UNAUTHORIZED_ERROR_TYPE || entry.errorCode === UNAUTHORIZED_ERROR_CODE
  );
